import React from 'react';
import Modal from 'react-modal';
import BoxBody from 'components/BoxBody';
import Button from 'components/Button';
import CoachingAddCoachingStreamDialog from 'coaching/components/CoachingCoordinatorView/CoachingAddCoachingStreamDialog';
import CoachingCoordinatorCoachList from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorCoachList';
import CoachingCoordinatorParticipantList from 'coaching/components/CoachingCoordinatorView/CoachingCoordinatorParticipantList';
import Heading from 'components/Heading';
import MediaObject from 'components/MediaObject';
import TabPanel from 'components/TabPanel';
import Tabs from 'components/Tabs';
import { GetParticipantList_coaching_getParticipantList_participants } from 'coaching/queries/__generated__/GetParticipantList';
import { GetCoachList_coaching_getCoachList_coaches } from 'coaching/queries/__generated__/GetCoachList';

export type ParticipantRow = GetParticipantList_coaching_getParticipantList_participants;
export type CoachRow = GetCoachList_coaching_getCoachList_coaches;

export type Props = {
  loadingParticipants: boolean;
  participants: ParticipantRow[];
  selectedParticipant?: ParticipantRow;
  onNextParticipantPage: () => Promise<void>;
  participantListHasNextPage?: boolean;
  onSelectParticipant: (participant: ParticipantRow) => void;

  loadingCoaches: boolean;
  coaches: CoachRow[];
  coachListHasNextPage?: boolean;
  onNextCoachPage: () => Promise<void>;

  onListTabsChange: (tabIndex: number) => void;
};

type State = {
  coachingStreamCreateDialogIsOpen: boolean;
};

export default class CoachingCoordinatorPeopleListView extends React.Component<Props, State> {
  state: State = {
    coachingStreamCreateDialogIsOpen: false,
  };

  showCoachingStreamCreateDialog = () => {
    this.setState({ coachingStreamCreateDialogIsOpen: true });
  };

  hideCoachingStreamCreateDialog = () => {
    this.setState({ coachingStreamCreateDialogIsOpen: false });
  };

  render() {
    return (
      <>
        <Modal isOpen={this.state.coachingStreamCreateDialogIsOpen}>
          <CoachingAddCoachingStreamDialog onRequestHide={this.hideCoachingStreamCreateDialog} />
        </Modal>
        <BoxBody>
          <MediaObject figure="right">
            <Heading level="1" serif>
              People
            </Heading>
            <Button level="secondary" size="xsmall" onClick={this.showCoachingStreamCreateDialog}>
              Create coaching chat
            </Button>
          </MediaObject>
          <Tabs flush={false} onTabChange={this.props.onListTabsChange}>
            <TabPanel title="Students">
              <CoachingCoordinatorParticipantList
                participants={this.props.participants}
                loadingParticipants={this.props.loadingParticipants}
                onSelectParticipant={this.props.onSelectParticipant}
                onNextPage={this.props.onNextParticipantPage}
                hasNextPage={this.props.participantListHasNextPage}
                selectedParticipant={this.props.selectedParticipant}
              />
            </TabPanel>
            <TabPanel title="Coaches">
              <CoachingCoordinatorCoachList
                coaches={this.props.coaches}
                loadingCoaches={this.props.loadingCoaches}
                onNextPage={this.props.onNextCoachPage}
                hasNextPage={this.props.coachListHasNextPage}
              />
            </TabPanel>
          </Tabs>
        </BoxBody>
      </>
    );
  }
}
